export const getVersion = (input) => {
  const regex = /@(\d+(?:\.\d+)*)(?:--|$)/;
  const match = input.match(regex);

  return match ? match[1] : null;
};
